export default __webpack_public_path__ + "static/media/tangmon.78707f11.png";